import { useContext } from 'react'
import { AppContext, AppContextType } from '@/AppContext'
import { ContextMediaStreams, UserContext, UserContextType } from '@/UserContext'
import { LocalVideoTrack } from 'livekit-client'
import { virtual_backgrounds } from '@/services/Constants'
import { uniqueId } from 'lodash'
import { BackgroundBlur, VirtualBackground } from '@/tools/track-processors'

let busy = false
export default function useVirtualBackgroundActions() {
    const { state: appState } = useContext(AppContext) as AppContextType
    const { dispatch } = useContext(UserContext) as UserContextType

    const setVirtualBackground = async (
        backgroundName: string | null,
        video: LocalVideoTrack | null,
        currentProcessor?: ContextMediaStreams['videoProcessor']
    ) => {
        if (busy) {
            return
        }
        busy = true

        if (!backgroundName) {
            await video?.stopProcessor()
            dispatch({
                type: 'update_media_streams',
                value: { videoProcessor: null },
            })
            dispatch({ type: 'update_media_selection', value: { selectedVirtualBackground: null } })
        } else if (backgroundName === 'blur') {
            if (!currentProcessor?.processor) {
                const blur = await BackgroundBlur(100, appState.appSettings.videoOptions?.optionFramerate)
                video?.setProcessor(blur)
                dispatch({
                    type: 'update_media_streams',
                    value: { videoProcessor: { name: 'blur', processor: blur, id: uniqueId() } },
                })
            } else {
                await currentProcessor.processor.updateTransformerOptions({
                    blurFilterRadius: 100,
                })
                dispatch({
                    type: 'update_media_streams',
                    value: {
                        videoProcessor: {
                            name: 'blur',
                            processor: currentProcessor.processor,
                            id: uniqueId(),
                        },
                    },
                })
            }
            dispatch({ type: 'update_media_selection', value: { selectedVirtualBackground: 'blur' } })
        } else {
            const image = virtual_backgrounds.find((vb) => vb.name === backgroundName)?.image
            if (image) {
                if (!currentProcessor?.processor) {
                    const virtualBackground = await VirtualBackground(
                        image,
                        appState.appSettings.videoOptions?.optionFramerate
                    )
                    await video?.setProcessor(virtualBackground)
                    dispatch({
                        type: 'update_media_streams',
                        value: {
                            videoProcessor: {
                                name: backgroundName,
                                processor: virtualBackground,
                                id: uniqueId(),
                            },
                        },
                    })
                } else {
                    await currentProcessor.processor.updateTransformerOptions({
                        backgroundImage: image,
                    })
                    dispatch({
                        type: 'update_media_streams',
                        value: {
                            videoProcessor: {
                                name: backgroundName,
                                processor: currentProcessor.processor,
                                id: uniqueId(),
                            },
                        },
                    })
                }
                dispatch({ type: 'update_media_selection', value: { selectedVirtualBackground: backgroundName } })
            }
        }
    }

    busy = false
    return { setVirtualBackground }
}
